import { render, staticRenderFns } from "./ShippingInstructionEquipments.vue?vue&type=template&id=6ded8986&scoped=true&"
import script from "./ShippingInstructionEquipments.vue?vue&type=script&lang=js&"
export * from "./ShippingInstructionEquipments.vue?vue&type=script&lang=js&"
import style0 from "./ShippingInstructionEquipments.vue?vue&type=style&index=0&id=6ded8986&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ded8986",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ded8986')) {
      api.createRecord('6ded8986', component.options)
    } else {
      api.reload('6ded8986', component.options)
    }
    module.hot.accept("./ShippingInstructionEquipments.vue?vue&type=template&id=6ded8986&scoped=true&", function () {
      api.rerender('6ded8986', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/shipping-instruction/ShippingInstructionEquipments.vue"
export default component.exports